export const SALES_ORDER_REGISTER_REPORT_REQUEST = 'SALES_ORDER_REGISTER_REPORT_REQUEST';
export const SALES_ORDER_REGISTER_REPORT_SUCCESS = 'SALES_ORDER_REGISTER_REPORT_SUCCESS';
export const SALES_ORDER_REGISTER_REPORT_FAILURE = 'SALES_ORDER_REGISTER_REPORT_FAILURE';